import type { SVGProps } from 'react';

/** Figma `metric-breath.svg` — `tools/make-icon-components.py`가 만든다. 손으로 고치지 않는다. */
export const MetricBreathIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g id="Frame">
      <path
        id="Vector"
        d="M1.63672 6.54688C4.09126 6.54688 4.09126 8.18324 6.54581 8.18324C9.00035 8.18324 9.00035 6.54688 11.4549 6.54688C13.9094 6.54688 13.9094 8.18324 16.364 8.18324M1.63672 11.456C4.09126 11.456 4.09126 13.0923 6.54581 13.0923C9.00035 13.0923 9.00035 11.456 11.4549 11.456C13.9094 11.456 13.9094 13.0923 16.364 13.0923"
        stroke="#FB2337"
        strokeWidth="1.6"
        strokeLinecap="round"
      />
    </g>
  </svg>
);
